import { render, staticRenderFns } from "./Egressos.vue?vue&type=template&id=4f9063c2&"
import script from "./Egressos.vue?vue&type=script&lang=ts&"
export * from "./Egressos.vue?vue&type=script&lang=ts&"
import style0 from "./Egressos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports